module.exports = __webpack_public_path__ + "04_short_brown.12316db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/04_short_brown.png
// module id = u8+C
// module chunks = 0